












import { defineComponent, computed, onMounted, onUnmounted, ref, PropType, watch } from '@vue/composition-api';
import Constants from '@/utils/Constants';
import MiApiWrapper from '@/utils/MiApiWrapper';
import useMainLayout from '@/composables/useMainLayout';
import MainLayoutInfo from '@/data/layout/MainLayoutInfo';

export default defineComponent({
  name: 'miPlayer',
  props: {
    videoId: {
      type: String,
      required: true
    },
    playerId: {
      type: String,
      required: true
    },
    contextId: {
      type: String,
      default: ''
    }
  },
  setup(props) {

    const miPlayerElem = ref<HTMLDivElement|null>(null);
    const { fullWidth, layoutType } = useMainLayout();
    let miApiWrapper: MiApiWrapper | undefined = undefined;
    const initDone = ref(false);

    const miPlayerConainerId = computed(() => {
      return `miPlayer${props.contextId}`;
    });
    const minHeightC = computed(() => {
      const minHeight = MainLayoutInfo.getPrimaryMainWidth(layoutType.value) / Constants.videoDefaultAspectRatio;
      if(minHeight > 0) return minHeight + 32 + 'px';
      return ((fullWidth.value - MainLayoutInfo.getGlobalMarginH(layoutType.value)) / Constants.videoDefaultAspectRatio) + 32 + 'px';
    });

    watch(
      () => props.videoId,
      (newVideoId) => {
        if(miApiWrapper) {
          miApiWrapper.switchVideo(newVideoId);
        }
      }
    );

    onMounted(async () => {

      miApiWrapper = new MiApiWrapper(miPlayerConainerId.value, props.playerId, props.videoId);
      const timeoutId = setTimeout(() => {
        initDone.value = true;
      }, 3000);
      await miApiWrapper.initPlayer();
      clearTimeout(timeoutId);
      initDone.value = true;
    });

    onUnmounted(async () => {
      if(miApiWrapper) {
        // Hint: do not delete the player on unmount. Since the API change, player can not be readded.
        //await miApiWrapper.deletePlayer();
      }
    });

    return {
      miPlayerElem,
      minHeightC,
      miPlayerConainerId,
      initDone
    };
  }
});
